import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type8TimestampTable } from "./type8Timestamp.table";

@Component({
  selector: "spec-app-type8-timestamp-list-window",
  templateUrl: "./type8Timestamp.list.html",
  styleUrls: ["./type8Timestamp.list.scss"]
})
export class Type8TimestampListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type8TimestampTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type8TimestampPage",
      this.tab.system,
      (object) => `Type8Timestamp at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type8TimestampList reload");
    super.reload();
    this.table.refreshList();
  }
}
